import { SelectProps } from 'antd';
import TcSelect from 'components/UI/form/input/TcSelect';
import { FC, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';

interface ITcSelectReduxSearch extends SelectProps {
  value?: string | number | undefined | null;
  labelPropertyName?: string;
  prefixLabelPropertyName?: string;
  reducerName: string;
  reducerListProperty: string;
  getlist: any;
  onChange?: (_a: string | number) => void;
  onChangeFullInfo?: (_a: any) => void;
  underValue?: boolean;
}

const TcSelectReduxSearch: FC<ITcSelectReduxSearch> = ({
  value,
  reducerName,
  reducerListProperty,
  underValue,
  onChange,
  onChangeFullInfo,
  getlist,
  labelPropertyName = 'title',
  prefixLabelPropertyName,
  ...props
}) => {
  //states
  const state = useSelector((state: any) => state[reducerName]);
  const optionsList = underValue ? state.value[reducerListProperty] : state[reducerListProperty];

  //effect
  useEffect(() => {
    !optionsList && store.dispatch(getlist());
  }, []);

  //functions
  const handleChange = (e: any) => {
    onChange && onChange(e);
    if (onChangeFullInfo) {
      const item = optionsList?.find((item: any) => item.id === e);
      onChangeFullInfo({ ...item, label: item.title, value: item.id });
    }
  };
  const getLabel = (item: any) => {
    const label = item[labelPropertyName];

    if (prefixLabelPropertyName) {
      const prefix = item[prefixLabelPropertyName];
      if (prefix) return prefix + ' - ' + label;
    }
    return label;
  };
  const options = useMemo(() => optionsList?.map((item: any) => ({ label: getLabel(item), value: item.id })), [optionsList]);

  return (
    <TcSelect
      showSearch
      allowClear
      loading={!optionsList}
      placeholder='انتخاب کنید'
      optionFilterProp='children'
      options={options}
      {...props}
      onChange={handleChange}
      value={value && +value}
    />
  );
};

export default TcSelectReduxSearch;
